import React, { Component } from 'react';
import { RelatorioBSMaisNaoMembros } from 'ebs-orders-reports-react-lib';
import { Configurations } from '../../../Utils/Configurations';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import './No-Members-Orders.scss';
import axios from 'axios';

class NoMembersOrders extends Component {


    constructor() {
        super();

        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.getReportsSubscribesNoMembers = this.getReportsSubscribesNoMembers.bind(this);

        this.Configurations = new Configurations();


        this.state = {
            hasError: false,
            errorMessage: '',
            isLoading: true,
            progressaoAssinaturas: [],
            faixaEtaria: []

        }
    }

    componentDidMount() {
        this.getReportsSubscribesNoMembers();
    }

    getReportsSubscribesNoMembers() {
        this.setState({ isLoading: true });
        const _bsMaisNoMembers = axios.get(this.Configurations.apiBasePath + `/pedidos/relatorios/bs-mais/nao-membros/ativas`);
        _bsMaisNoMembers.then(response => {
            this.setState({
                totalAssinaturas: response.data.resumoAssinaturas.totalAssinaturas,
                periodoAssinatura: response.data.resumoAssinaturas.periodoAssinatura,
                tipoLogin: response.data.resumoAssinaturas.tipoLogin,
                progressaoAssinaturas: response.data.resumoAssinaturas.progressaoAssinaturas,
                faixaEtaria: response.data.resumoAssinaturas.faixaEtaria

            });
        }).catch(this.handleError).finally(() => this.setState({
            isLoading: false
        }));
    }



    handleError(err) { this.setState({ hasError: true, errorMessage: err.message }) }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    render() {
        return (
            <React.Fragment>
                <RelatorioBSMaisNaoMembros
                    isLoading={this.state.isLoading}
                    totalAssinaturas={this.state.totalAssinaturas}
                    periodoAssinatura={this.state.periodoAssinatura}
                    tipoLogin={this.state.tipoLogin}
                    progressaoAssinaturas={this.state.progressaoAssinaturas}
                    faixaEtaria={this.state.faixaEtaria}
                />
                <ErrorModal isOpen={this.state.hasError} message={this.state.errorMessage} closeErrorModal={this.closeErrorModal} />
            </React.Fragment>
        )



    }
}

export default NoMembersOrders;